module.exports = __webpack_public_path__ + "media/img/venue-90e37f25ac705cc63bbbfeb7629cbfe1.jpg";